<template>
    <v-app id="inspire">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                <v-flex xs12 sm8 md8 lg4>
                    <v-card class="elevation-5 pa-3">
                    <v-card-text>
                        <div class="layout column align-center"><br>
                        <img :src="getLogo" alt="Control Panel - Login"  height="auto" class="mt-1 mb-4" :width="($vuetify.breakpoint.smAndDown) ? '80%' : '50%;'">
                        <br>
                        <div>
                            <p class="headline font-weight-medium text-center">Control Panel - Login</p>
                        </div>
                        <!--<div>
                            <p class="title font-weight-medium text-center">Prijava</p>
                        </div>-->
                        <v-layout align-center justify-center="">
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="">
                                    <p style="text-align:center;" class="font-weight-medium">Fill in your email and password to login.</p>
                                </div>
                            </v-flex>
                        </v-layout>
                        </div>                
                        <br>
                        <v-form v-if="loginForm" ref="loginForm" v-model="valid" lazy-validation>
                            <v-text-field
                                append-icon="mdi-email"
                                name="login" label="E-mail" 
                                type="email" 
                                :rules="emailRules" 
                                v-model="credentials.username"
                                :error="error"
                                :error-messages="errors['message']"
                                @keyup.enter="login"
                                color="tertiary"
                                >
                            </v-text-field>
                            <v-text-field id="password" append-icon="mdi-lock" name="password" label="Password" type="password" :rules="passwordRules" v-model="credentials.password" @keyup.enter="login" color="tertiary"></v-text-field>
                            <!-- H o n e y p o t -->
                            <label class="ohnohoney" for="name"></label>
                            <input class="ohnohoney" v-model="hpot.name" autocomplete="off" type="text" id="name" name="name" placeholder="Your name here">
                            <label class="ohnohoney" for="email"></label>
                            <input class="ohnohoney" v-model="hpot.email" autocomplete="off" type="email" id="email" name="email" placeholder="Your e-mail here">
                        </v-form>
                        <v-card-text v-else>
                            <v-layout align-center justify-center>
                                <v-flex xs12 sm12 md12 lg12>
                                    <div class="text-center">
                                        <v-btn v-if="!$vuetify.breakpoint.xsOnly" color="secondary" @click="displayLoginForm()" :loading="loginFormLoading">Click to login </v-btn>
                                        <v-btn v-else color="secondary" block @click="loginForm = true">Click to login</v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card-text>
                    <span v-if="loginForm">
                        <v-card-actions v-if="!$vuetify.breakpoint.xsOnly">
                            <v-spacer></v-spacer>
                            <v-btn  v-if="loginForm" class="white--text" dark color="secondary" @click.native="login" :loading="loginLoading">Login</v-btn>
                            <v-btn  v-if="loginForm" class="white--text" dark color="secondary" @click.native='passwordReset'>Forgot password?</v-btn>
                            <br><br>
                        </v-card-actions>
                        <v-card-text v-else>
                            <v-btn  v-if="loginForm" block outlined  style="margin-bottom:10px;" class="white--text" dark color="secondary" @click.native="login" :loading="loginLoading">Login</v-btn>
                            <v-btn  v-if="loginForm" outlined block class="white--text" dark color="secondary" @click.native='passwordReset'>Forgot password?</v-btn>
                        </v-card-text>
                    </span>
                    <br v-if="!loginForm">
                    </v-card>
                </v-flex>
                </v-layout>
            </v-container>
            <network-status></network-status>
        </v-main>
    </v-app> 
</template>

<script>
import router from '@/router'
import { post } from '@/helpers/api'
import logo from '@/assets/logo.png'
const NetworkStatus = () =>import('@/components/NetworkStatus')

export default {
    name: 'login',
    components: {
        NetworkStatus
    },
    props: {
        source: String
    },

    data: () => ({
        title: process.env.VUE_APP_TITLE,
        valid: true,
        avatarSize: 32,
        tile: true,
        drawer: null,
        credentials: {
            //email: '', //spa
            //password: '' //spa
            username: '',
            password: ''
        },

        emailRules: [
            (v) => !!v || 'Email is required.',
            (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email address not valid.'
        ],
        passwordRules: [
            (v) => !!v || 'Password is required.',
            (v) => v.length >= 6 || 'Passwords must be at least 8 characters in length, but can be much longer.'
        ],

        hpot: {
            name: null,
            email: null
        },

        loginForm: false,
        loginFormLoading: false,

        timeout1: null,

        loginLoading: false,
        error: false,
        errors: {}
    }),

    computed: {
        getLogo() {
            return logo
        }
    },

    methods: {
        login() {
           if(this.$refs.loginForm.validate() && ((this.hpot.name == null || this.hpot.name == "") && (this.hpot.email == null || this.hpot.email == "")) ) {
            this.loginLoading = true;
            this.error = false;
            this.errors = {}
            this.credentials.grant_type = process.env.VUE_APP_GRANT_TYPE; // ko je token auth
            this.credentials.client_id = process.env.VUE_APP_CLIENT_ID; // ko je token auth
            //let login = this.$store.dispatch('LOGIN_SPA', this.credentials)
            let login = this.$store.dispatch('LOGIN', this.credentials)
              .then(response => {
                //window.console.log(("XXX"))
                //window.console.log(response)

                    return router.push({ name: 'invoices'});
                })
                .catch(error => {
                    window.console.log("Error")
                    window.console.log(error.response)
                    window.console.log(error)
                    this.error = true;
                    this.loginLoading = false;
                    if(error.response.status == 401) {
                    this.errors = { message: "Invalid email or password." }
                    }
                    else {
                    this.errors = { message: "Sorry, something went wrong there. Try again."}
                    }
                })
                .then(() => {
                    this.loginLoading = false;
                })
            } 
        },

        passwordReset() {
            this.$router.push({
                name: 'passwordResetRequest'
            })
        },

        displayLoginForm() {
            this.loginFormLoading = true
            this.timeout1 = setTimeout(() => {
                this.loginFormLoading = false
                this.loginForm = true

            }, 400)
        }
    },

    created() {

    },

    beforeDestroy() {
        clearTimeout(this.timeout1)
    }
}

</script>

<style scoped>
    #inspire{
        background-image: url("../../assets/bckpattern.png") !important;
        background-repeat: repeat !important;
    }

    .ohnohoney{
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 0;
        width: 0;
        z-index: -1;
    }
</style>